import { Icon } from '@/src/shared/components/Icon';
import styles from './FeatureItem.module.scss';
import { FeatureItemProps } from './types';
import { Typography } from '@/src/shared/components/Typography';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

export const FeatureItem = ({ item }: FeatureItemProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <Icon name={item.icon} fontSize={32} />
      </div>
      <div className={styles.textWrapper}>
        <Typography
          variant="text"
          size={isMobile ? 'lg' : 'xl'}
          fontWeight="semibold"
          className={styles.title}
        >
          {item.title}
        </Typography>
        <Typography tag="span" variant="text" size="md" fontWeight="regular">
          {item.subTitle}
        </Typography>
      </div>
    </div>
  );
};
